import styled from '@emotion/styled';
import Checked from '@engineering/icons/checked';

const UspWrapper = styled.div`
  padding-top: 1rem;
`;

const UspTitle = styled.h2`
  margin: 0 0 1rem;
  padding: 0;
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-size: 1.25rem;
  font-weight: bold;
  line-height: 1.25;
  color: ${({ theme }) => theme.colors.neutral.grey160};
`;

const UspList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0;
  padding: 0;
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-size: 1rem;
  line-height: 1.5;
  text-align: left;
  list-style: none;
`;

const UspItem = styled.li`
  display: flex;
  gap: 0.5rem;
`;

const UspIcon = styled(Checked)`
  flex: 0 0 auto;
  width: 1.5rem;
  height: 1.5rem;
  fill: ${({ theme }) => theme.colors.brand.green120};
`;

const UspDetails = styled.p`
  margin: 1rem 0 0;
  font-size: 1rem;
`;

export { UspWrapper, UspTitle, UspList, UspItem, UspIcon, UspDetails };
